import { Injectable, NgModule,Compiler } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject, throwError, of, timer } from 'rxjs';
import * as moment from 'moment';
import storageFallback from 'local-storage-fallback';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'

import { config } from '../remote_access_portal.config';
import { DeepstreamService } from '../deepstream/deepstream.service';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends AppService {

  public user: Subject<any>;
  public token: string = '';
  public loggedIn: boolean = false;

  private userSub;
  private options:any;
  private tokenTimer:any;
  private config : any = {};
  public userInfo: any = {
    id:0,
    username: 'Guest',
    roles: [],
    permissions: [],
    user_group: []
  };
  public vpn_status: boolean = false;
  public userInfoObservable: Observable<any>;
  public permissions: any = [];

  private loggedInAsBehaviorSubject : BehaviorSubject<any> = new BehaviorSubject(storageFallback.getItem('loggedInAs'));
  private LogInAs : any = false;

  private _tempOrgID : number;
  public tempOrgIDSubject : BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private router: Router,
    private http: HttpClient,
    private _compiler: Compiler,
    private activatedRoute: ActivatedRoute,
    private ds: DeepstreamService
  ) {
    super();

    this.user = new Subject();
		this.userInfoObservable = this.getLoginInfo();
    if(this.isAllowed() || this.loggedIn) {
      this.startTokenTimer();
      this.ds.dsLogin(this.getToken());
    }

    this.initLoginAs();
  }

	get dsInstance() {
		return this.ds.dsInstance;
	}

  get tempOrgID(): number {
    return this._tempOrgID;
  }

  set tempOrgID(id: number) {
    if (!id) id = this.userInfo.user_group[0].id;
    this._tempOrgID = id;
    this.tempOrgIDSubject.next(this._tempOrgID);
  }

  /**
   * Initialize login as behavior subject and default subscriber
   */
  initLoginAs(){
    //Intialize the value
    this.loggedInAsBehaviorSubject = new BehaviorSubject(storageFallback.getItem('loggedInAs'));
    //The default subscriber of loggedInAs
    this.loggedInAsBehaviorSubject.subscribe(
      //On Next event
      (user)=>{
        try {
          storageFallback.setItem('loggedInAs',user);
          //show toast message
        } catch(e) {
          if (this.isQuotaExceeded(e)) {
            console.log(e);
            this.handleError(e);
          }
        }
      },
      //Error event
      (error)=>{},
      //Complete event
      ()=>{
      });
    //watch permissions for logged in as
    this.watchPermissions();
  }

  private startTokenTimer() {
    this.tokenTimer = timer((1000*60),(1000*60)*5);
    this.tokenTimer.subscribe(t=> {
      this.checkToken();
    });

    // VPN Status
    setInterval(this.checkVPNStatus.bind(this), 60000);
  }

  ngOnDestroy() {
    if (this.tokenTimer && this.tokenTimer.unsubscribe !== undefined) this.tokenTimer.unsubscribe();
    if (this.userSub !== undefined) this.userSub.unsubscribe();
  }

  setToken(token) {
    storageFallback.setItem('currentUser',
      JSON.stringify(
        {   token: token,
          time: moment().format()
        }
      )
    );
    location.reload();
  }

  login(options):Observable<any> {
    return this.http.post(this.getBaseUrl() + config.LARAVEL_URL + 'login', options)
    .map((thisUser: any) => {
      this.token = thisUser.token;
      this.loggedIn = true;

      try {
        storageFallback.setItem('currentUser',
          JSON.stringify(
            {   token: this.token,
              time: moment().format()
            }
          )
        );
      } catch(e) {
        if (this.isQuotaExceeded(e)) {
          console.log(e);
          this.handleError(e);
          return false;
        }
      }

      this.userInfo = thisUser;
      this.userInfoObservable = this.getLoginInfo();
      this.ds.dsLogin(this.getToken());
      this.startTokenTimer();
      this.checkVPNStatus();
      return true;
    })
    .catch(this.handleLoginError.bind(this));
  }

  logout() {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken() });
    let options = { headers: headers };

    return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + 'user/logout', options)
    .subscribe(() => {
      if (this.userSub) this.userSub.unsubscribe();
      storageFallback.removeItem('currentUser');

      this.userInfo = { id:0, username: 'Guest', roles: [], permissions: [], user_group: [] };
      this.permissions = {};
      this.token = '';
      this.loggedIn = false;
      this.router.navigate(['/login']);
      window.location.reload();
    })
  }

  getLoginInfo():Observable<any> {
    if(this.isAllowed()) {
      let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken(),'X-Login-As': this.LogInAs || '' });
      let options = { headers: headers };

      return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + 'user/', options )
        .map((userInfo) => {
          this.userInfo = userInfo;
          this.populatePermissions();
          this.populateConfig();
          this.checkVPNStatus();
          return this.userInfo;
        })
        .catch(this.handleLoginError.bind(this))
    }

    console.log('not logged in')
    //return throwError("getLoginInfo: not allowed");
    this.router.navigate(['/login']);
    return new Observable();
  }

  get hasUserInfo(): boolean {
    return this.userInfo.id !== 0;
  }

  getLocalStorageToken() {
    try {
      let store: any = storageFallback.getItem('currentUser');
      if (store) {
        store = JSON.parse(store.toString());
        if (store && store.token) {
          return store.token;
        }
      } else {
        return false;
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  getToken() {
    try {
      let token = this.getLocalStorageToken();
      if(token)
        return token;
      else
        console.log('no token')
        this.router.navigate(['/login']);
        return false;
    } catch(e) {
      console.log(e)
      this.router.navigate(['/login']);
    }
  }

  isAllowed() {
    if (!storageFallback.getItem('currentUser')) {
      try {
        let token = this.getLocalStorageToken();
          if(token)
          return true;
        else
          return false;
      } catch(e) {
        return false;
      }
    }
    return true;
  }

  /**
   * Check if the logged in user has a specific role
   * @param role_name
   */
  public hasRole(role_name) {
    return this.userInfo.roles.filter(role => role.name == role_name).length ? true : false;
  }

  public can(perm) {
    return this.permissions[perm] === true;
    /*try {
    for(let i = 0; i < this.userInfo.roles.length; i++) {
        for(let l = 0; l < this.userInfo.roles[i].permissions.length; l++) {
            if(this.userInfo.roles[i].permissions[l].name == perm)
                return true;
        }
    }
    return false;
    } catch(e) {}*/
  }

  public populatePermissions() {
    //Case Where user belongs to user groups
    if (this.userInfo && this.userInfo.acl_user_group) {
      let permissions = {};
      for(let i = 0; i < this.userInfo.acl_user_group.roles.length; i++) {
        for(let l = 0; l < this.userInfo.acl_user_group.roles[i].permissions.length; l++) {
          permissions[this.userInfo.acl_user_group.roles[i].permissions[l].name] = true;
        }
      }
      this.permissions = permissions;
    }
  }

  private checkVPNStatus() {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken() });
    let options = { headers: headers };

    this.http.get(this.getBaseUrl() + config.LARAVEL_URL + 'user/devices/remote/' + this.userInfo.id, options)
      .subscribe((data: any) => {
        if (data) this.vpn_status = data.vpn;
      })
  }

  private checkToken() {
    let store: any = storageFallback.getItem('currentUser');
    if (store) {
      store = JSON.parse(store.toString());
      if (store && store.time) {
        let refreshTime = moment(store.time).add(60, 'minutes');

        if(moment().isAfter(refreshTime)) {
          // refreshToken() isn't working, so just reload the page
          //this.refreshToken();
          console.log('time to refresh token'); // XXX
          // location.reload();
        }
      }
    }
  }

  public refreshToken() {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken() });
    let options = { headers: headers };

    this.http.post(this.getBaseUrl() + config.LARAVEL_URL +'refresh-token', {}, options)
      .subscribe((data: any) => {
        this.ds.dsLogin(this.getToken());
      });
  }

  private getBaseUrl(){
    // return location.protocol + '//' + location.hostname + (location.port ? ':'+location.port : '') + '/'
    return '/'; // relative URI to enable automatic XSRF by Angular
  }

  private notifyDeviceOffline() {
    console.log("Your device has gone offline!");
  }

  private notifyDevice() {
    console.log("Your device has come online!");
  }

  private handleLoginError(error:any) {
    if (error.status == 401) {
      this.router.navigate(['/login'], {});
    } else if (error.status == 400) {
      // Future TODO: refreshToken
      localStorage.removeItem('currentUser');
      window.location.reload();
    }
    return throwError(error);
  }

  private handleError(error:any) {

    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';

    if(error.status == '401' && this.loggedIn) {
      try {
        this.refreshToken();
      }catch(e) {console.log(e)}
    }

    return throwError(errMsg);
  }

  private isQuotaExceeded(e) {
    var quotaExceeded = false;
    if (e) {
      if (e.code) {
        switch (e.code) {
          case 22:
            quotaExceeded = true;
            break;
          case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
              quotaExceeded = true;
            }
            break;
        }
      } else if (e.number === -2147024882) {
        // Internet Explorer 8
        quotaExceeded = true;
      }
    }
    return quotaExceeded;
  }

  private populateConfig(){
    let config = {} ;
    for(let i = 0; i < this.userInfo.settings.length; i++) {
      config[this.userInfo.settings[i].name] = this.userInfo.settings[i].value;
    }
    this.config = config;
  }

  public getConfig(name){
    return this.config[name];
  }

  /**
   * This method creates a new loggedInAs behavior subject and assigns a value to it.
   * @param user
   */
  public switchAccount(user){
    this.loggedInAsBehaviorSubject.next(JSON.stringify(user));
    this.clearCache();
  }

  /**
   * Get Logged in details
   */
  public getLoggedInAs(){
    return this.loggedInAsBehaviorSubject.asObservable().map(value=>JSON.parse(value) ? JSON.parse(value) : {});
  }

  /**
   * Clear the switch account details
   */
  public clearSwitchAccount(){
    this.loggedInAsBehaviorSubject.next(null);
    this.clearCache();
  }

  private  clearCache(){
    // this.router.navigate(['']).then(()=>{
    //   window.location.reload();
    // });
  }

  private watchPermissions(){
    this.getLoggedInAs().subscribe((user)=>{
      this.LogInAs = user.id;
      this.getLoginInfo();
    });
  }

  get loggedInAs() {
    return this.LogInAs;
  }

  getSubOrgs(group_id):Observable<any> {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken() });
    let options = { headers: headers };

    return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + 'user/sub_orgs/'+group_id, options)
    .catch(this.handleError)
  }
}

